import type { PatchEventInput } from '../../api/calendar';

/**
 * ⭐ 반복 일정 「이 일정만」·「전체 일정」 수정은 «바꾼 칸만» 보낸다 (2026-10-14 사용자 확정 · 반복 규칙 1단계 A).
 *
 *   · 「이 일정만」 — 회차 덮어쓰기(override)에 바꾼 칸만 남아, 나머지 칸은 시리즈를 계속 따라간다.
 *   · 「전체 일정」 — 바꾼 칸만 나뉜 시리즈 전부에 간다(다른 조각이 따로 가진 값을 덮지 않는다).
 * 내용 칸(제목·설명·유형·완료·장소)은 원래 값과 견주어 같으면 뺀다. 시각·캘린더·반복 칸은 부르는 쪽이 이미
 * «바뀐 경우에만» 싣으므로 그대로 둔다. 서버도 기존 override 와 병합한다(이중 안전).
 */
export function pickChangedEditFields(
  body: PatchEventInput,
  original: { title: string; description?: string | null; type: string; done?: boolean | null; location?: string | null },
): PatchEventInput {
  const out: PatchEventInput = { ...body };
  const norm = (v: string | null | undefined) => (v ?? '').trim();
  if (out.title !== undefined && out.title === original.title) delete out.title;
  if (out.description !== undefined && norm(out.description) === norm(original.description)) delete out.description;
  if (out.type !== undefined && out.type === original.type) delete out.type;
  if (out.done !== undefined && out.done === Boolean(original.done)) delete out.done;
  if (out.location !== undefined && norm(out.location) === norm(original.location)) delete out.location;
  for (const k of Object.keys(out) as Array<keyof PatchEventInput>) {
    if (out[k] === undefined) delete out[k];
  }
  return out;
}
